import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

export * as model from './model'

// skin
const skin = era.skin('shared/ui/components/NoContentBlock')

NoContentBlock.displayName = 'NoContentBlock'
export function NoContentBlock(): JSX.Element | null {
  return (
    <ui.RenderSkin from={skin} name='noContentBlock' key='noContentBlock' />
  )
}
